/* eslint
    import/extensions: "warn",
    default-case: "warn",
    @typescript-eslint/no-shadow: "warn",
    no-redeclare: "warn",
    prefer-regex-literals: "warn",
    no-return-assign: "warn"
*/

import { element, globalEvent } from '@shared/easyfy.core';
import { addCss, parseToBoolean, removeCss } from '@shared/easyfy.utils';
import prescriptionService from '@webServices/prescription.service';
import Litepicker from 'litepicker/dist/nocss/litepicker.umd.js';

export enum ModalType {
    AddChildProxy = 1,
    GiveAnimalConsent = 2,
    RemoveProxy = 3,
    ApproveAwaitingProxy = 4,
    GiveProxy = 5,
    PharmaceuticalAdvice = 6,
    DrugList = 7,
    SavedPrescriptions = 8,
    FassDocument = 9,
    LoggedOut = 10,
    ExchangeInfoModal = 11,
    HowTo = 12
}

export default class PrescriptionModal {
    private Id: string;

    static Instance: PrescriptionModal;

    static loaderString = '<div class="loader loader-small loader-white" role="status" aria-live="polite" aria-label="Laddar"></div>';

    private datePicker: Litepicker;

    constructor() {
        PrescriptionModal.Instance = this;
        PrescriptionModal.Instance.Id = window.performance.now().toString();
        globalEvent({
            type: 'click',
            event: {
                action: 'modal-close',
                callback: PrescriptionModal.CloseOnClick
            }
        });
        globalEvent({
            type: 'click',
            event: {
                action: 'modal-main-action',
                callback: PrescriptionModal.MainAction
            }
        });

        globalEvent({
            type: 'click',
            event: {
                action: 'modal-step-action',
                callback: PrescriptionModal.StepAction
            }
        });

        globalEvent({
            type: 'click',
            event: {
                action: 'modal-step-back',
                callback: PrescriptionModal.StepBackAction
            }
        });

        globalEvent({
            type: 'click',
            event: {
                action: 'approve-awaiting-proxy',
                callback: PrescriptionModal.TryApproveAwaitingProxy
            }
        });

        globalEvent({
            type: 'click',
            event: {
                action: 'reject-awaiting-proxy',
                callback: PrescriptionModal.TryRejectAwaitingProxy
            }
        });
    }

    public AppendModal = (
        type: ModalType,
        appendToElement: HTMLElement,
        data?: any
    ) => {
        if (type) {
            let partialHtml;
            switch (type) {
                case ModalType.AddChildProxy: {
                    prescriptionService
                        .GetAddChildModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.GiveAnimalConsent: {
                    prescriptionService
                        .GetAnimalConsentModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.RemoveProxy: {
                    if (!data) return;

                    const removeData: prescriptionService.RemoveProxyCommand = {
                        ssn: data.ssn,
                        name: data.name,
                        isChild: data.isChild,
                        isReceived: data.isReceived
                    };

                    prescriptionService
                        .GetRemoveProxyModal(removeData)
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.ApproveAwaitingProxy: {
                    if (!data) return;
                    const approveData: prescriptionService.ApproveAwaitingProxyCommand = {
                        ssn: data.ssn,
                        consent: false
                    };

                    prescriptionService
                        .GetApproveAwaitingProxyModal(approveData)
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.GiveProxy: {
                    prescriptionService
                        .GetGiveProxyModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                                const date = new Date();
                                PrescriptionModal.Instance.datePicker = new Litepicker({
                                    element: document.getElementById(
                                        'proxy-date-picker'
                                    ) as HTMLElement,
                                    parentEl: document.getElementById(
                                        'date-picker-container'
                                    ) as HTMLElement,
                                    lang: 'sv-SE',
                                    dropdowns: {
                                        minYear: date.getFullYear(),
                                        maxYear: date.getFullYear() + 4,
                                        months: true,
                                        years: true
                                    },
                                    inlineMode: true,
                                    singleMode: true
                                });

                                PrescriptionModal.Instance.datePicker.show();

                                const modal = element(
                                    `[data-modal-id="${PrescriptionModal.Instance.Id}"] .modal-inner-wrapper`
                                ) as HTMLElement;
                                if (!modal) return;
                                const radioButtons = modal.querySelectorAll(
                                    'input[type="radio"]'
                                );

                                radioButtons.forEach((radio) =>
                                    radio.addEventListener(
                                        'change',
                                        PrescriptionModal.SetDatePicker
                                    )
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.PharmaceuticalAdvice: {
                    prescriptionService
                        .GetPharmaceuticalAdviceModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.DrugList: {
                    prescriptionService
                        .GetDrugListModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.SavedPrescriptions: {
                    prescriptionService
                        .GetSavedPrescriptionsModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.FassDocument: {
                    if (!data) return;
                    prescriptionService
                        .GetFassDocumentModal(data.header)
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );

                                const fassDocumentData: prescriptionService.FassDocumentRequest =
                                {
                                    id: data.id,
                                    isNplPackId: data.isNplPackId,
                                    isAnimal: data.isAnimal
                                };
                                prescriptionService
                                    .GetFassDocument(fassDocumentData)
                                    .then((response) => {
                                        if (response.status === 200 && response.data != null) {
                                            const container = element(
                                                '[data-container="fass-document"]'
                                            ) as HTMLElement;
                                            if (container) {
                                                container.innerHTML = response.data.documentString;
                                            }
                                        }
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                    });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.LoggedOut: {
                    prescriptionService
                        .GetLogoutModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.ExchangeInfoModal: {
                    prescriptionService
                        .GetExchangeInfoModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                case ModalType.HowTo: {
                    prescriptionService
                        .GetHowToModal()
                        .then((response) => {
                            if (response.status === 200 && response.data != null) {
                                PrescriptionModal.renderModalPartial(
                                    response.data.html,
                                    appendToElement,
                                    type
                                );
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    break;
                }
                default: {
                    console.warn(`PrescriptionModal: No modal type found for ${type}`);
                }
            }
        }
    };

    public OnClose?: (success: boolean, data?: any) => void;

    static CloseOnClick = (e: any) => {
        if (e?.target?.className === 'modal-inner-wrapper') {
            return;
        }
        PrescriptionModal.CloseModal(false, null);
    };

    static CloseModal = (actionSuccess: boolean, data?: any) => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;

        modal.parentNode.removeChild(modal);

        if (!PrescriptionModal.Instance.OnClose) return;
        if (typeof actionSuccess === 'boolean') {
            PrescriptionModal.Instance.OnClose(actionSuccess, data);
        } else {
            PrescriptionModal.Instance.OnClose(false, data);
        }
    };

    static MainAction = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        const type = modal.getAttribute('data-modal-type');
        if (!type) return;

        switch (type) {
            case ModalType.AddChildProxy.toString(): {
                PrescriptionModal.TryAddChild();
                break;
            }
            case ModalType.GiveAnimalConsent.toString(): {
                PrescriptionModal.TryConsentAnimal();
                break;
            }
            case ModalType.RemoveProxy.toString(): {
                PrescriptionModal.TryRemoveProxy();
                break;
            }
            case ModalType.GiveProxy.toString(): {
                PrescriptionModal.TryGiveProxyFinal();
                break;
            }
            default: {
                console.warn(`PrescriptionModal: No main action found for ${type}`);
            }
        }
    };

    static StepAction = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        const type = modal.getAttribute('data-modal-type');
        if (!type) return;

        switch (type) {
            case ModalType.GiveProxy.toString(): {
                PrescriptionModal.Instance.TryGiveProxyStep();
                break;
            }
            default: {
                console.warn(`PrescriptionModal: No step action found for ${type}`);
            }
        }
    };

    static StepBackAction = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        const type = modal.getAttribute('data-modal-type');
        if (!type) return;

        // clear the form when stepping back
        modal.querySelectorAll('.modal-message').forEach(item => item.innerHTML = '');
        const checkBoxElement = modal.querySelector(
            '.modal-inner-wrapper input[type="checkbox"]'
        ) as HTMLInputElement;
        checkBoxElement.checked = false;

        switch (type) {
            case ModalType.GiveProxy.toString(): {
                const stepTwoContainer = element(
                    `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-second-step]`
                ) as HTMLElement;

                const closeButton = stepTwoContainer.querySelector(
                    'button[data-action="modal-step-back"]'
                ) as HTMLButtonElement;

                const closeModalOnCancel = closeButton.getAttribute('close-modal-on-cancel');
                if (closeModalOnCancel) {
                    closeButton.removeAttribute('close-modal-on-cancel');
                    PrescriptionModal.CloseModal(false, null);
                }
                else {
                    PrescriptionModal.Instance.GiveProxyStepBack();
                }

                break;
            }
            default: {
                console.warn(`PrescriptionModal: No step back action found for ${type}`);
            }
        }
    };

    private static renderModalPartial = (
        html: string,
        appendToElement: HTMLElement,
        type: ModalType
    ) => {
        let modal = document.createElement('modal');
        modal.setAttribute('data-modal-id', PrescriptionModal.Instance.Id);
        modal.setAttribute('data-modal-type', type.toString());
        modal.removeAttribute('data-modal-created');
        modal.innerHTML = html;
        const htmlAsNode = modal.getRootNode();
        appendToElement.appendChild(htmlAsNode);

        // TODO: Probably dead code.
        modal = document.querySelector('[data-modal-created]') as HTMLElement;
    };

    private static TryAddChild = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;

        if (!modal) {
            return;
        }

        const messageContainer = modal.querySelector(
            '.modal-message'
        ) as HTMLDivElement;
        messageContainer.innerHTML = '';

        const inputElement = modal.querySelector(
            '.modal-inner-wrapper input[type="text"]'
        ) as HTMLInputElement;

        console.log(inputElement.value);
        const ssnIsValid = PrescriptionModal.ValidateSsn(inputElement.value);
        console.log(inputElement.value);

        if (!ssnIsValid) {
            messageContainer.innerHTML = 'Ange personnummer (12 siffror)';
            return;
        }

        const checkBoxElement = modal.querySelector(
            '.modal-inner-wrapper input[type="checkbox"]'
        ) as HTMLInputElement;
        const token = inputElement.attributes['data-token']?.value;
        const ssnInput = inputElement.value;
        const savePersistent = checkBoxElement.checked;
        const addButton = modal.querySelector(
            '[data-action="modal-main-action"]'
        ) as HTMLButtonElement;
        const closeButton = modal.querySelector(
            'button[data-action="modal-close"]'
        ) as HTMLButtonElement;

        checkBoxElement.setAttribute('disabled', 'disabled');
        inputElement.setAttribute('disabled', 'disabled');
        addButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');

        const currentButtonText = addButton.innerHTML;
        addButton.innerHTML += PrescriptionModal.loaderString;

        const postData: prescriptionService.AddChildProxyCommand = {
            ssn: ssnInput,
            savePersistent
        };

        prescriptionService
            .PostAddChildProxy(postData, token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, {
                            ssn: postData.ssn
                        });
                    } else {
                        (
                            modal.querySelector('.modal-message') as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                checkBoxElement.removeAttribute('disabled');
                inputElement.removeAttribute('disabled');
                addButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');

                addButton.innerHTML = currentButtonText;
            });
    };

    private static TryConsentAnimal = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        (modal.querySelector('.modal-message') as HTMLDivElement).innerHTML = '';
        const addButton = modal.querySelector(
            '[data-action="modal-main-action"]'
        ) as HTMLButtonElement;
        const closeButton = modal.querySelector(
            'button[data-action="modal-close"]'
        ) as HTMLButtonElement;
        const token = addButton.attributes['data-token']?.value;

        addButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');

        const currentButtonText = addButton.innerHTML;
        addButton.innerHTML += PrescriptionModal.loaderString;

        prescriptionService
            .PostConsentAnimal(token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, null);
                    } else {
                        (
                            modal.querySelector('.modal-message') as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                addButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');
                addButton.innerHTML = currentButtonText;
            });
    };

    private static TryRemoveProxy = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        (modal.querySelector('.modal-message') as HTMLDivElement).innerHTML = '';
        const removeButton = modal.querySelector(
            '[data-action="modal-main-action"]'
        ) as HTMLButtonElement;
        const closeButton = modal.querySelector(
            'button[data-action="modal-close"]'
        ) as HTMLButtonElement;
        const token = removeButton.attributes['data-token']?.value;

        removeButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');

        const currentButtonText = removeButton.innerHTML;
        removeButton.innerHTML += PrescriptionModal.loaderString;

        const data: prescriptionService.RemoveProxyCommand = {
            ssn: removeButton.attributes['data-ssn']?.value,
            name: removeButton.attributes['data-name']?.value,
            isChild: !!removeButton.attributes['data-is-child'],
            isReceived: !!removeButton.attributes['data-is-received']
        };

        prescriptionService
            .PostRemoveProxy(data, token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, null);
                    } else {
                        (
                            modal.querySelector('.modal-message') as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                removeButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');
                removeButton.innerHTML = currentButtonText;
            });
    };

    private static TryRejectAwaitingProxy = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        (modal.querySelector('.modal-message') as HTMLDivElement).innerHTML = '';
        const rejectButton = modal.querySelector(
            '[data-action="reject-awaiting-proxy"]'
        ) as HTMLButtonElement;
        const approveButton = modal.querySelector(
            '[data-action="approve-awaiting-proxy"]'
        ) as HTMLButtonElement;
        const closeButton = modal.querySelector(
            'button[data-action="modal-close"]'
        ) as HTMLButtonElement;

        const token = rejectButton.attributes['data-token']?.value;

        rejectButton.setAttribute('disabled', 'disabled');
        approveButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');

        const currentButtonText = rejectButton.innerHTML;
        rejectButton.innerHTML += PrescriptionModal.loaderString;

        const data: prescriptionService.RemoveProxyCommand = {
            ssn: rejectButton.attributes['data-ssn']?.value,
            name: rejectButton.attributes['data-name']?.value,
            isChild: !!rejectButton.attributes['data-is-child'],
            isReceived: !!rejectButton.attributes['data-is-received']
        };

        prescriptionService
            .PostRemoveProxy(data, token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, null);
                    } else {
                        (
                            modal.querySelector('.modal-message') as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                rejectButton.removeAttribute('disabled');
                approveButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');
                rejectButton.innerHTML = currentButtonText;
            });
    };

    private static TryApproveAwaitingProxy = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        (modal.querySelector('.modal-message') as HTMLDivElement).innerHTML = '';
        const acceptButton = modal.querySelector(
            '[data-action="approve-awaiting-proxy"]'
        ) as HTMLButtonElement;
        const rejectButton = modal.querySelector(
            'button[data-action="reject-awaiting-proxy"]'
        ) as HTMLButtonElement;
        const closeButton = modal.querySelector(
            'button[data-action="modal-close"]'
        ) as HTMLButtonElement;
        const token = acceptButton.attributes['data-token']?.value;
        const checkBoxElement = modal.querySelector(
            '.modal-inner-wrapper input[type="checkbox"]'
        ) as HTMLInputElement;
        const consentGiven = checkBoxElement.checked;

        acceptButton.setAttribute('disabled', 'disabled');
        rejectButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');
        checkBoxElement.setAttribute('disabled', 'disabled');

        const currentButtonText = acceptButton.innerHTML;
        acceptButton.innerHTML += PrescriptionModal.loaderString;

        const data: prescriptionService.ApproveAwaitingProxyCommand = {
            ssn: acceptButton.attributes['data-ssn']?.value,
            consent: consentGiven
        };

        prescriptionService
            .PostApproveAwaitingProxy(data, token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, null);
                    } else {
                        (
                            modal.querySelector('.modal-message') as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                acceptButton.removeAttribute('disabled');
                rejectButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');
                checkBoxElement.removeAttribute('disabled');
                acceptButton.innerHTML = currentButtonText;
            });
    };

    private static ValidateSsn = (ssn: string): boolean => {
        ssn = ssn.replace(/[^\d]+/g, '').trim();
        const regex = new RegExp('^[0-9]{12}$');
        return regex.test(ssn);
    };

    private TryGiveProxyStep = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] .modal-inner-wrapper`
        ) as HTMLElement;
        if (!modal) return;
        const messageContainer = modal.querySelector(
            '.modal-message'
        ) as HTMLDivElement;
        messageContainer.innerHTML = '';
        const inputElement = modal.querySelector(
            'input[type="text"]'
        ) as HTMLInputElement;
        const radioButtons = modal.querySelectorAll('input[type="radio"]');

        const ssnIsValid = PrescriptionModal.ValidateSsn(inputElement.value);

        if (!ssnIsValid) {
            messageContainer.innerHTML = 'Ange personnummer (12 siffror)';
            return;
        }

        if ((radioButtons[0] as HTMLInputElement).checked) {
            PrescriptionModal.Instance.GiveProxyStepTwo(
                inputElement.value,
                true,
                null
            );
        } else {
            const dateInput = modal.querySelector(
                '#proxy-date-picker'
            ) as HTMLInputElement;
            if (dateInput.value) {
                PrescriptionModal.Instance.GiveProxyStepTwo(
                    inputElement.value,
                    false,
                    dateInput.value
                );
            } else {
                messageContainer.innerHTML = 'Datum ej valt';
            }
        }
    };

    private GiveProxyStepTwo = (
        ssn: string,
        isIndefiniteProxy: boolean,
        date?: string
    ) => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] .modal-inner-wrapper`
        ) as HTMLElement;
        if (!modal) return;
        const stepOneContainer = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-first-step]`
        ) as HTMLElement;
        const stepTwoContainer = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-second-step]`
        ) as HTMLElement;

        stepTwoContainer.setAttribute(
            'data-is-indefinite-proxy',
            isIndefiniteProxy ? 'true' : 'false'
        );
        stepTwoContainer.setAttribute('data-proxy-ssn', ssn);
        if (date) {
            stepTwoContainer.setAttribute('data-proxy-date', date);
        }

        removeCss(stepTwoContainer, 'hidden');
        addCss(stepOneContainer, 'hidden');
    };

    private GiveProxyStepBack = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] .modal-inner-wrapper`
        ) as HTMLElement;
        if (!modal) return;
        const stepOneContainer = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-first-step]`
        ) as HTMLElement;
        const stepTwoContainer = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-second-step]`
        ) as HTMLElement;

        addCss(stepTwoContainer, 'hidden');
        removeCss(stepOneContainer, 'hidden');
    };

    private static TryGiveProxyFinal = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] .modal-inner-wrapper`
        ) as HTMLElement;
        if (!modal) return;
        const stepTwoContainer = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"] [data-second-step]`
        ) as HTMLElement;
        const actionButton = stepTwoContainer.querySelector(
            '[data-action="modal-main-action"]'
        ) as HTMLButtonElement;
        const closeButton = stepTwoContainer.querySelector(
            'button[data-action="modal-step-back"]'
        ) as HTMLButtonElement;
        const checkBoxElement = stepTwoContainer.querySelector(
            '[data-second-step] input[type="checkbox"]'
        ) as HTMLInputElement;

        actionButton.setAttribute('disabled', 'disabled');
        closeButton.setAttribute('disabled', 'disabled');
        checkBoxElement.setAttribute('disabled', 'disabled');
        const currentButtonText = actionButton.innerHTML;
        actionButton.innerHTML += PrescriptionModal.loaderString;

        const consent = checkBoxElement.checked;
        const isIndefinite = parseToBoolean(
            stepTwoContainer.attributes['data-is-indefinite-proxy']?.value
        );
        const ssn = stepTwoContainer.attributes['data-proxy-ssn']?.value;
        const pickedDate = isIndefinite
            ? null
            : stepTwoContainer.attributes['data-proxy-date']?.value;
        const token = stepTwoContainer.attributes['data-token']?.value;

        const data: prescriptionService.GiveProxyCommand = {
            consent,
            isIndefiniteDate: isIndefinite,
            ssn,
            pickedDate
        };

        prescriptionService
            .PostGiveProxy(data, token)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (response.data.success) {
                        PrescriptionModal.CloseModal(true, null);
                    } else
                    {
                        if (response.data.closeModalOnCancel) {
                            closeButton.setAttribute('close-modal-on-cancel', response.data.closeModalOnCancel);
                        }
                        (
                            stepTwoContainer.querySelector(
                                '.modal-message[data-second-step]'
                            ) as HTMLDivElement
                        ).innerHTML = response.data.message;
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                actionButton.removeAttribute('disabled');
                closeButton.removeAttribute('disabled');
                checkBoxElement.removeAttribute('disabled');
                actionButton.innerHTML = currentButtonText;
            });
    };
    static SetDatePicker = () => {
        const modal = element(
            `[data-modal-id="${PrescriptionModal.Instance.Id}"]`
        ) as HTMLElement;
        if (!modal) return;
        const datePicker = element('#date-picker-container');
        const radioButtons = modal.querySelectorAll('input[type="radio"]');
        if ((radioButtons[0] as HTMLInputElement).checked) {
            removeCss(datePicker, 'display');
        } else if ((radioButtons[1] as HTMLInputElement).checked) {
            addCss(datePicker, 'display');
        }
    };
}
